import React from 'react'
import { forwardRef, ReactNode } from 'react'
import classNames from 'classnames'
import { Button } from '../Button'

export interface BreadcrumbItemProps {
    active?: boolean
    className?: string
    onClick?: () => void
    children?: ReactNode
}

const BreadcrumbItem = forwardRef<HTMLLIElement, BreadcrumbItemProps>(({
    children,
    active,
    className,
    onClick,
    ...otherProps
}, ref) => {

    const _className = classNames(
        'breadcrumb-item',
        {
            active: active
        },
        className
    )

    return (
        <li
            ref={ref}
            className={_className}
            {...(active && { 'aria-current': 'page' })}
            {...otherProps}>
            {(onClick) ?
                <Button
                    color="link"
                    // no button box: the crumb shares the active crumb's baseline and the
                    // separator spacing instead of adding .btn padding and border around it
                    className="p-0 border-0 align-baseline"
                    onClick={onClick}>
                    {children}
                </Button>
                :
                children
            }
        </li>
    )
})

export { BreadcrumbItem }
